(function () {
    'use strict';

    app.controller('accessOptionController', ['$scope', '$location', '$cookies', 'LoginService', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', 'UpgradeService', '$routeParams', 'indBulkPurchaseService', '$filter', function ($scope, $location, $cookies, loginService, AuthenticationService, progressBarService, $rootScope, $timeout, upgradeService, $routeParams, indBulkPurchaseService, $filter) {
        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return;
        }

        $scope.states = [];
        $scope.billingstates = [];
        $scope.isError = false;
        $scope.isSuccess = false;
        $scope.isRemoveAppliedCoupon = false;
        $scope.disableIndAutorenew = false;

        $scope.serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

        $timeout(function () {
            indBulkPurchaseService.setAccessOptionScope($scope);
        }, 100);

        var name = getLocalValue("fullName").split(' ');
        $scope.firstName = name[0];
        $scope.lastName = name[1];

        $scope.purchasedCostEstimation = {
            productId: 0, durationInWords: "", isMonthly: 1, packagePurchased: "", quantity: 0, total: 0, discountPercent: 0, grandTotal: 0, recurringAmount: 0
        };

        $scope.teamAccess = function () {
            $location.path('/accessOption/team');
        }

        $scope.indAccess = function () {
            $location.path('/accessOption/ind');
        }

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = ''
        }

        var isPopupAppeared = false;

        $scope.calculateTotal = function (scope) {

            if (scope != undefined) {
                $scope = scope;
            }

            if ($routeParams.accessType == 'ind') {
                var indChkAutoBiling = $('#indChkAutoBiling')[0];
                if ($scope.indSubscriptionData.indOrderQuantity > 1) {

                    $scope.indSubscriptionData.indAutoRenewal = false;

                    if (indChkAutoBiling != undefined) {
                        indChkAutoBiling.disabled = true;
                    }

                    if (isPopupAppeared == false) {
                        $('#popupForTeam').modal('show');
                        isPopupAppeared = true;
                    }
                } else {
                    if (indChkAutoBiling != undefined) {
                        indChkAutoBiling.disabled = false;
                    }
                }

                if ($scope.purchasedCostEstimation.isMonthly == 1) {
                    monthlyCalculateTotal();
                }
                else if ($scope.purchasedCostEstimation.isMonthly == 0) {
                    yearlyCalculateTotal();
                }
            } else if ($routeParams.accessType == 'team') {
                teamCalculateTotal();
            }
        }

        function monthlyCalculateTotal() {
            var isProductChanged = true;
            $scope.purchasedCostEstimation.durationInWords = "month";
            $scope.purchasedCostEstimation.packagePurchased = "Monthly Individual";
            $scope.purchasedCostEstimation.quantity = $scope.indSubscriptionData.indOrderQuantity;
            $scope.purchasedCostEstimation.total = $scope.perSeat.month * $scope.purchasedCostEstimation.quantity;
            var matched = false;
            $.each($scope.monthlyProduct, function (value, key) {
                if (key.eSpectraOrderMin <= $scope.purchasedCostEstimation.quantity && key.eSpectraOrderMax >= $scope.purchasedCostEstimation.quantity) {
                    $scope.purchasedCostEstimation.productId = key.eSpectraProductID;

                    isProductChanged = $scope.purchasedCostEstimation.isMonthly != $scope.currentProduct;

                    //if (key.eSpectraDiscountPCent > 0 && matched == false) {
                    //    var discounted = $scope.purchasedCostEstimation.total * key.eSpectraDiscountPCent;
                    //    $scope.purchasedCostEstimation.grandTotal = ($scope.purchasedCostEstimation.total - discounted);
                    //    matched = true;
                    //}
                }
            });

            $scope.currentProduct = $scope.purchasedCostEstimation.isMonthly;

            if (matched == false) {
                $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.total;
            }

            $scope.purchasedCostEstimation.recurringAmount = parseFloat($scope.purchasedCostEstimation.grandTotal).toFixed(2);

            applyCoupon(isProductChanged);
        }

        function yearlyCalculateTotal() {
            var isProductChanged = true;

            $scope.purchasedCostEstimation.durationInWords = "year";
            $scope.purchasedCostEstimation.packagePurchased = "Annual Individual";
            $scope.purchasedCostEstimation.quantity = $scope.indSubscriptionData.indOrderQuantity;
            $scope.purchasedCostEstimation.total = $scope.perSeat.year * $scope.purchasedCostEstimation.quantity;
            var matched = false;
            $.each($scope.yearlyProduct, function (value, key) {
                $scope.purchasedCostEstimation.productId = key.eSpectraProductID;

                isProductChanged = $scope.purchasedCostEstimation.isMonthly != $scope.currentProduct;

                //if (key.eSpectraOrderMin <= $scope.purchasedCostEstimation.quantity && key.eSpectraOrderMax >= $scope.purchasedCostEstimation.quantity) {
                //    if (key.eSpectraDiscountPCent > 0 && matched == false) {
                //        var discounted = $scope.purchasedCostEstimation.total * key.eSpectraDiscountPCent;
                //        $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.total - discounted;
                //        matched = true;
                //    }
                //}
            });

            $scope.currentProduct = $scope.purchasedCostEstimation.isMonthly;

            if (matched == false) {
                $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.total;
            }

            $scope.purchasedCostEstimation.recurringAmount = parseFloat($scope.purchasedCostEstimation.grandTotal).toFixed(2);

            applyCoupon(isProductChanged);
        }

        function teamCalculateTotal() {
            var isProductChanged = true;

            $scope.purchasedCostEstimation.durationInWords = "year";
            $scope.purchasedCostEstimation.packagePurchased = "Team Subscription";
            $scope.purchasedCostEstimation.quantity = $scope.teamSubscriptionData.teamOrderQuantity;
            //$scope.purchasedCostEstimation.total = $scope.perSeat.team * $scope.purchasedCostEstimation.quantity;
            var matched = false;
            $.each($scope.teamProduct, function (value, key) {
                $scope.purchasedCostEstimation.productId = key.eSpectraProductID;

                isProductChanged = $scope.purchasedCostEstimation.isMonthly != $scope.currentProduct;

                if (key.eSpectraOrderMin <= $scope.purchasedCostEstimation.quantity && key.eSpectraOrderMax >= $scope.purchasedCostEstimation.quantity) {
                    $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.quantity * key.eSpectraUnitPrice;
                    $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.grandTotal.toFixed(2);
                    matched = true;
                    //if (key.eSpectraDiscountPCent > 0 && matched == false) {
                    //    var discounted = $scope.purchasedCostEstimation.total * key.eSpectraDiscountPCent;
                    //    $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.total - discounted;
                    //    $scope.purchasedCostEstimation.discountPercent = key.eSpectraDiscountPCent * 100;
                    //    matched = true;
                    //}
                }
            });

            $scope.currentProduct = $scope.purchasedCostEstimation.isMonthly;

            if (matched == false) {
                $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.total;
                $scope.purchasedCostEstimation.discountPercent = 0;
            }

            applyCoupon(isProductChanged);
        }

        function applyCoupon(isProductChanged) {
            var isError = false;
            if (isProductChanged) {
                if ($scope.coupon.discountValue != "") {
                    isError = true;
                }

                $scope.purchasedCostEstimation.grandTotal = parseFloat($scope.purchasedCostEstimation.grandTotal).toFixed(2);
            } else if ($scope.coupon.discountValue != "") {
                if ($scope.coupon.discountType == "money") {
                    $scope.discountedValue = $scope.coupon.discountValue;
                } else if ($scope.coupon.discountType == "percent") {
                    $scope.discountedValue = $scope.purchasedCostEstimation.grandTotal * ($scope.coupon.discountValue / 100);
                } else {
                    $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.grandTotal.toFixed(2);
                }

                if ($scope.discountedValue != undefined && $scope.discountedValue != 0) {
                    if ($scope.purchasedCostEstimation.grandTotal >= $scope.discountedValue) {
                        $scope.purchasedCostEstimation.grandTotal = ($scope.purchasedCostEstimation.grandTotal - $scope.discountedValue).toFixed(2);
                        $scope.indSubscriptionData.indAutoRenewal = $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? false : $scope.indSubscriptionData.indAutoRenewal;
                        $scope.disableIndAutorenew = $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? true : $scope.disableIndAutorenew;
                        $scope.couponMessage = GetMessage.couponSuccessMessage;
                        $('.couponMessage').addClass('couponSuccess');
                        removeCouponMessage();
                    } else {
                        isError = true;
                    }
                }
            }
            if (isError) {
                $scope.couponMessage = GetMessage.couponInvalidMessage;
                $('.couponMessage').addClass('couponError');
                clearCoupon();
                removeCouponMessage();
            }
        }

        function clearCoupon() {
            $scope.coupon = {
                discountValue: 0,
                discountType: "",
                prodDiscountID: 0
            }

            $scope.indSubscriptionData.discountCode = "";
            $scope.teamSubscriptionData.discountCode = "";
        }

        function removeCouponMessage() {
            if ($scope.couponMessage != undefined) {
                $timeout(function () {
                    if ($scope.couponMessage != undefined) {
                        $scope.isRemoveAppliedCoupon = $scope.couponMessage == GetMessage.couponSuccessMessage ? true : false
                        delete $scope.couponMessage
                        $('.couponMessage').removeClass('couponError')
                        $('.couponMessage').removeClass('couponSuccess')
                    }
                }, 5000);
            }
        }

        ///SubscriptionDataModel
        $scope.subscribtionDataModel = function () {
            $scope.indSubscriptionData = {
                indFirstName: "",
                indLastName: "",
                indEmailId: $scope.email,
                indAddress: "",
                indAddress2: "",
                indCity: "",
                indState: "",
                indOtherState: "",
                indCountry: "",
                indZipCode: "",
                indBillingAddress: "",
                indBillingAddress2: "",
                indBillingCity: "",
                indBillingState: "",
                indBillingOtherState: "",
                indBillingCountry: "",
                indBillingZipCode: "",
                indAutoRenewal: true,
                indOrderQuantity: "1",
                discountCode: ""
            }

            $scope.teamSubscriptionData = {
                teamFirstName: "",
                teamLastName: "",
                teamEmailId: $scope.email,
                teamAddress: "",
                teamAddress2: "",
                teamCity: "",
                teamState: "",
                teamOtherState: "",
                teamCountry: "",
                teamZipCode: "",
                teamBillingAddress: "",
                teamBillingAddress2: "",
                teamBillingCity: "",
                teamBillingState: "",
                teamBillingOtherState: "",
                teamBillingCountry: "",
                teamBillingZipCode: "",

                teamOrderQuantity: "2",
                discountCode: ""
            }

            clearCoupon();

            $('form[name="indForm"]').trigger('reset');
            if (this.indForm) {
                this.indForm.$setPristine();
                this.indForm.$setUntouched();
            }

            $('form[name="teamForm"]').trigger('reset');
            if (this.teamForm) {
                this.teamForm.$setPristine();
                this.teamForm.$setUntouched();
            }
        }

        $scope.subscribtionDataModel();

        function isTeamAdminHasTeam() {
            $.ajax({
                url: $scope.serviceBase + 'api/team/hasTeam',
                async: true,
                type: "GET",
                dataType: "json",
                data: {}
            }).success(function (data) {
                if (!data) {
                    $("#teamSetup").modal('show');
                }
            }).error(function (data, status) {
                $scope.message = GetMessage.ApiError;
                $scope.isError = true;
                $scope.isSuccess = false;
            });
        }

        //getProducts
        $scope.getProducts = function () {
            progressBarService.showProgressBar();
            upgradeService.getSubscriptionProducts().then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {

                    assignProduct(response);

                    loginService.setUserDetail($scope.email).then(function (response) {
                        if (response != null && response.data.message == undefined) {
                            var userData = response.data;

                            if (response.data.eSpectraRecurringBillFlag == "1") {
                                progressBarService.showProgressBar();
                                $scope.isError = true;
                                $scope.message = 'You can not purchase individual subscription as autorenewal is on. Redirecting to profile page.....';
                                $timeout(function () {
                                    $location.path('/profile');
                                }, 3000)
                            } else {
                                if ($routeParams.accessType == 'ind') {
                                    $scope.indSubscriptionData.indState = userData.eSpectraStateCode;
                                    $scope.indSubscriptionData.indFirstName = userData.eSpectraFirstName;
                                    $scope.indSubscriptionData.indLastName = userData.eSpectraLastName;
                                    $scope.indSubscriptionData.indEmailId = userData.eSpectraEmail;
                                    $scope.indSubscriptionData.indAddress = userData.eSpectraStreetAddrs1;
                                    $scope.indSubscriptionData.indAddress2 = userData.eSpectraStreetAddrs2;
                                    $scope.indSubscriptionData.indCity = userData.eSpectraCity;
                                    $scope.indSubscriptionData.indCountry = userData.countryIso2,
                                    $scope.indSubscriptionData.indZipCode = userData.eSpectraZipPostalCode;
                                } else if ($routeParams.accessType == 'team') {
                                    $scope.teamSubscriptionData.teamFirstName = userData.eSpectraFirstName;
                                    $scope.teamSubscriptionData.teamLastName = userData.eSpectraLastName;
                                    $scope.teamSubscriptionData.teamEmailId = userData.eSpectraEmail;
                                    $scope.teamSubscriptionData.teamAddress = userData.eSpectraStreetAddrs1;
                                    $scope.teamSubscriptionData.teamAddress2 = userData.eSpectraStreetAddrs2;
                                    $scope.teamSubscriptionData.teamCity = userData.eSpectraCity;
                                    $scope.teamSubscriptionData.teamCountry = userData.countryIso2,
                                    $scope.teamSubscriptionData.teamZipCode = userData.eSpectraZipPostalCode;
                                }
                                $scope.getcountryData();
                                progressBarService.hideProgressBar();
                            }
                        }

                    });
                }
            });
        }
        //assign product
        function assignProduct(response) {
            $scope.perSeat = {
                month: "",
                year: "",
                team: "",
                maxSeats: 0
            }

            $scope.monthlyProduct = response.data.monthlyProduct;
            $scope.perSeat.month = $scope.monthlyProduct[0].eSpectraUnitPrice;
            $scope.perSeat.maxSeats = $scope.monthlyProduct[$scope.monthlyProduct.length - 1].eSpectraOrderMax;
            $scope.yearlyProduct = response.data.yearlyProduct;
            $scope.perSeat.year = $scope.yearlyProduct[0].eSpectraUnitPrice;
            $scope.perSeat.maxSeats = $scope.yearlyProduct[$scope.yearlyProduct.length - 1].eSpectraOrderMax;
            $scope.teamProduct = response.data.teamProduct;
            $scope.perSeat.team = $scope.teamProduct[0].eSpectraUnitPrice;
            $scope.perSeat.maxSeats = $scope.teamProduct[$scope.teamProduct.length - 1].eSpectraOrderMax;
            $scope.email = response.data.loggedInEmailId;
            $scope.indSubscriptionData.indEmailId = $scope.email;
            $scope.teamSubscriptionData.teamEmailId = $scope.email;

            $scope.calculateTotal();
        }

        $scope.indSubscribe = function () {
            progressBarService.showProgressBar();

            if ($scope.indSubscriptionData.indOrderQuantity > 1) {
                indBulkPurchaseService.isValidBulkSubscription = true;
                $location.path('/indBulkSubscribe/ind', false);
                return
            }

            var upgradeData = {
                eSpectraLicenceKeyStatus: 'Assigned',
                eSpectraSubAssignedPersonEmail: $scope.indSubscriptionData.indEmailId,
                eSpectraFirstName: $scope.firstName,
                eSpectraLastName: $scope.lastName,
                eSpectraOrderQty: $scope.indSubscriptionData.indOrderQuantity,
                eSpectraOrderIsMonthly: $scope.purchasedCostEstimation.isMonthly,
                eSpectraOrderTS: new Date(),
                eSpectraProductID: $scope.purchasedCostEstimation.productId,
                eSpectraOrderTotalCost: $scope.purchasedCostEstimation.grandTotal,
                eSpectraCCBillFirstName: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indFirstName,
                eSpectraCCBillLastName: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indLastName,
                eSpectraCCBillStreetAddrs1: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indBillingAddress,
                eSpectraCCBillStreetAddrs2: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indBillingAddress2,
                eSpectraCCBillCity: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indBillingCity,
                eSpectraCCBillZipPostalCode: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indBillingZipCode,
                eSpectraCCBillStateCode: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indBillingState,
                eSpectraCCBillCountryID: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.indSubscriptionData.indBillingCountry,
                eSpectraRecurringBillFlag: $scope.indSubscriptionData.indAutoRenewal ? 1 : 0,
                eSpectraProdDiscountID: $scope.coupon.prodDiscountID,
                RecurringAmount: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? 0.00 : $scope.purchasedCostEstimation.recurringAmount
            }
            $scope.getSignature(upgradeData);
        }

        $scope.teamSubscribe = function () {
            progressBarService.showProgressBar();
            var teamPartyID = getLocalValue("teamPartyID");

            var upgradeData = {
                eSpectraOrderQty: $scope.teamSubscriptionData.teamOrderQuantity,
                eSpectraOrderTS: new Date(),
                eSpectraProductID: $scope.purchasedCostEstimation.productId,
                eSpectraTeamPartyID: teamPartyID,
                eSpectraFirstName: $scope.firstName,
                eSpectraOrderTotalCost: $scope.purchasedCostEstimation.grandTotal,
                eSpectraCCBillFirstName: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamFirstName,
                eSpectraCCBillLastName: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamLastName,
                eSpectraCCBillStreetAddrs1: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamBillingAddress,
                eSpectraCCBillStreetAddrs2: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamBillingAddress2,
                eSpectraCCBillCity: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamBillingCity,
                eSpectraCCBillZipPostalCode: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamBillingZipCode,
                eSpectraCCBillStateCode: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamBillingState,
                eSpectraCCBillCountryID: $scope.purchasedCostEstimation.grandTotal.toString() == '0.00' ? "" : $scope.teamSubscriptionData.teamBillingCountry,
                eSpectraProdDiscountID: $scope.coupon.prodDiscountID
            }

            $scope.getTeamSignature(upgradeData);
        }

        $scope.getSignature = function (upgradeData, scope) {

            if (scope != undefined) {
                $scope = scope;
            }

            upgradeService.getSignature(upgradeData).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    progressBarService.hideProgressBar();
                }
                else {

                    if (response.data.result && response.data.signature == undefined) {
                        var subscriptionData = response.data.subscriptionData;
                        var subscriptionType = subscriptionData.eSpectraOrderIsMonthly == 1 ? 'Monthly' : 'Annual';
                        var subscriptionTerm = subscriptionData.eSpectraOrderIsMonthly == 1 ? 'month' : 'year';
                        $scope.message = GetMessage.freeSubscription(subscriptionType, subscriptionTerm);
                        $scope.isSuccess = true;
                        $scope.isError = false;
                        $scope.indSubscriptionData.indAutoRenewal = true;
                        $scope.disableIndAutorenew = false;
                        $scope.subscribtionDataModel();
                        $scope.getProducts();
                        $scope.purchasedCostEstimation.isMonthly = 1;
                        $scope.currentProduct = 1;
                    } else {

                        var data = response.data.signature;

                        $scope.cybersourceAPI = response.data.signature.CyberSourceTokenAPI;
                        document.payment_confirmation.action = $scope.cybersourceAPI;
                        if (document.autorenewal_payment_confirmation != undefined) {
                            document.autorenewal_payment_confirmation.action = $scope.cybersourceAPI;
                        }

                        var payData = {
                            access_key: data.access_key,
                            profile_id: data.profile_id,
                            transaction_uuid: data.transaction_uuid,
                            signed_field_names: data.signed_field_names,
                            unsigned_field_names: data.unsigned_field_names,
                            signed_date_time: data.signed_date_time,
                            locale: data.locale,
                            transaction_type: data.transaction_type,
                            reference_number: data.reference_number,
                            amount: data.amount,
                            currency: data.currency,
                            signature: data.signature,
                            bill_to_forename: data.bill_to_forename,
                            bill_to_surname: data.bill_to_surname,
                            bill_to_email: data.bill_to_email,
                            bill_to_address_line1: data.bill_to_address_line1,
                            bill_to_address_line2: data.bill_to_address_line2,
                            bill_to_address_city: data.bill_to_address_city,
                            bill_to_address_postal_code: data.bill_to_address_postal_code,
                            bill_to_address_state: data.bill_to_address_state,
                            bill_to_address_country: data.bill_to_address_country,
                            recurring_frequency: data.recurring_frequency,
                            recurring_amount: data.recurring_amount,
                            recurring_start_date: data.recurring_start_date,
                            override_custom_cancel_page: data.override_custom_cancel_page,
                            override_custom_receipt_page: data.override_custom_receipt_page,
                            override_backoffice_post_url: data.override_backoffice_post_url
                        }

                        $scope.GetSignature = payData;
                        if (data.eSpectraRecurringBillFlag == 1) {
                            window.setTimeout(function () {
                                $('#autorenewalsubmit').click();
                            }, 100)
                        } else {
                            window.setTimeout(function () {
                                $('#submit').click();
                            }, 100)
                        }
                    }

                    progressBarService.hideProgressBar();
                }
            });
        }

        $scope.getTeamSignature = function (upgradeData) {

            upgradeService.getTeamSignature(upgradeData).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    progressBarService.hideProgressBar();
                }
                else {

                    if (response.data.result && response.data.signature == undefined) {
                        var subscriptionType = 'Annual';
                        var subscriptionTerm = 'year';
                        $scope.message = GetMessage.freeSubscription(subscriptionType, subscriptionTerm);
                        $scope.isSuccess = true;
                        $scope.isError = false;
                        $scope.subscribtionDataModel();
                        $scope.getProducts();
                        $scope.currentProduct = 0;
                    } else {

                        var data = response.data.signature;

                        $scope.cybersourceAPI = response.data.signature.CyberSourceTokenAPI;
                        document.payment_confirmation.action = $scope.cybersourceAPI;
                        document.autorenewal_payment_confirmation.action = $scope.cybersourceAPI;

                        var payData = {
                            access_key: data.access_key,
                            profile_id: data.profile_id,
                            transaction_uuid: data.transaction_uuid,
                            signed_field_names: data.signed_field_names,
                            unsigned_field_names: data.unsigned_field_names,
                            signed_date_time: data.signed_date_time,
                            locale: data.locale,
                            transaction_type: data.transaction_type,
                            reference_number: data.reference_number,
                            amount: data.amount,
                            currency: data.currency,
                            signature: data.signature,
                            bill_to_forename: data.bill_to_forename,
                            bill_to_surname: data.bill_to_surname,
                            bill_to_email: data.bill_to_email,
                            bill_to_address_line1: data.bill_to_address_line1,
                            bill_to_address_line2: data.bill_to_address_line2,
                            bill_to_address_city: data.bill_to_address_city,
                            bill_to_address_postal_code: data.bill_to_address_postal_code,
                            bill_to_address_state: data.bill_to_address_state,
                            bill_to_address_country: data.bill_to_address_country,
                            recurring_frequency: data.recurring_frequency,
                            recurring_amount: data.recurring_amount,
                            recurring_start_date: data.recurring_start_date,
                            override_custom_cancel_page: data.override_custom_cancel_page,
                            override_custom_receipt_page: data.override_custom_receipt_page,
                            override_backoffice_post_url: data.override_backoffice_post_url
                        }

                        $scope.GetSignature = payData;

                        window.setTimeout(function () {
                            $('#submit').click();
                        }, 100);
                    }
                    progressBarService.hideProgressBar();
                }
            });
        }

        $scope.validateCoupon = function (scope) {

            if (scope != undefined) {
                $scope = scope;
            }

            if ($scope.coupon.prodDiscountID > 0) {
                return;
            }

            $scope.indSubscriptionData.indAutoRenewal = true;
            $scope.disableIndAutorenew = false;

            $scope.couponMessage = "";
            var couponCode = $routeParams.accessType == "ind" ? $scope.indSubscriptionData.discountCode : $scope.teamSubscriptionData.discountCode;
            if (couponCode == "" || couponCode == undefined || couponCode == null) {
                $scope.couponMessage = GetMessage.couponInvalidMessage;
                $('.couponMessage').addClass('couponError');
                removeCouponMessage();
                //return;
            }
            var data = {
                eSpectraProductId: $scope.purchasedCostEstimation.productId,
                discountCode: couponCode
            }

            upgradeService.validateCoupon(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.couponMessage = response.data.message;
                    $('.couponMessage').addClass('couponError');

                    removeCouponMessage();
                    clearCoupon();
                } else {
                    if (response.data.eSpectraValueType != "") {
                        $scope.coupon.discountValue = response.data.eSpectraDiscountValue;
                        $scope.coupon.discountType = response.data.eSpectraValueType;
                        $scope.coupon.prodDiscountID = response.data.eSpectraProdDiscountID;

                        applyCoupon(false);

                    } else {
                        $scope.couponMessage = GetMessage.couponInvalidMessage;
                        $('.couponMessage').addClass('couponError');
                        clearCoupon();
                        removeCouponMessage();
                    }
                }
            });
        }

        $scope.removeAppliedCoupon = function () {
            $scope.purchasedCostEstimation.grandTotal = (parseFloat($scope.purchasedCostEstimation.grandTotal) + $scope.discountedValue);
            $scope.purchasedCostEstimation.grandTotal = $scope.purchasedCostEstimation.grandTotal.toFixed(2);
            $scope.indSubscriptionData.indAutoRenewal = true;
            $scope.disableIndAutorenew = false;
            $scope.coupon.prodDiscountID = 0;
            $scope.coupon.discountValue = 0;
            if ($routeParams.accessType == "ind") {
                $scope.indSubscriptionData.discountCode = ''
            }
            else {
                $scope.teamSubscriptionData.discountCode = ''
            }
            $scope.isRemoveAppliedCoupon = false;
        }

        if ($routeParams.accessType == 'team') {
            $('.privacy-container').addClass('team-access');
            $('.team-privacy-btn').addClass('disabled');
            isTeamAdminHasTeam();
            $scope.getProducts();
            $scope.currentProduct = 0;
        } else if ($routeParams.accessType == 'ind') {
            $('.privacy-container').addClass('individual-access');
            $('.individual-privacy-btn').addClass('disabled');
            $scope.getProducts();
            $scope.currentProduct = 1;
        }

        //address same as above
        $scope.chkbillingAddress = function () {
            if ($routeParams.accessType == 'ind') {
                $scope.isBillingAddressSame = false;
                var isChecked = $('#indChkBiling')[0].checked;
                if (isChecked) {
                    $scope.isBillingAddressSame = true;
                    $scope.indSubscriptionData.indBillingCountry = $scope.indSubscriptionData.indCountry;
                    $scope.getBillingStateData($scope.indSubscriptionData.indBillingCountry);

                    $scope.indSubscriptionData.indBillingState = $scope.indSubscriptionData.indState;

                    $scope.indSubscriptionData.indBillingOtherState = $scope.indSubscriptionData.indOtherState;


                    $scope.indSubscriptionData.indBillingAddress = $scope.indSubscriptionData.indAddress;
                    $scope.indSubscriptionData.indBillingAddress2 = $scope.indSubscriptionData.indAddress2;
                    $scope.indSubscriptionData.indBillingCity = $scope.indSubscriptionData.indCity;
                    $scope.indSubscriptionData.indBillingZipCode = $scope.indSubscriptionData.indZipCode;

                    $scope.indSelectedBillingCountryZipCodeRegEx = $scope.indSelectedCountryZipCodeRegEx;
                    $scope.indBillingCountryZipCodeRequiredFlag = $scope.indCountryZipCodeRequiredFlag;

                }
            } else if ($routeParams.accessType == 'team') {
                $scope.isBillingAddressSame = false;
                var isChecked = $('#teamChkBiling')[0].checked;
                if (isChecked) {
                    $scope.isBillingAddressSame = true;
                    $scope.teamSubscriptionData.teamBillingCountry = $scope.teamSubscriptionData.teamCountry;
                    $scope.getBillingStateData($scope.teamSubscriptionData.teamBillingCountry);

                    $scope.teamSubscriptionData.teamBillingState = $scope.teamSubscriptionData.teamState;

                    $scope.teamSubscriptionData.teamBillingOtherState = $scope.teamSubscriptionData.teamOtherState;


                    $scope.teamSubscriptionData.teamBillingAddress = $scope.teamSubscriptionData.teamAddress;
                    $scope.teamSubscriptionData.teamBillingAddress2 = $scope.teamSubscriptionData.teamAddress2;
                    $scope.teamSubscriptionData.teamBillingCity = $scope.teamSubscriptionData.teamCity;
                    $scope.teamSubscriptionData.teamBillingZipCode = $scope.teamSubscriptionData.teamZipCode;

                    $scope.teamSelectedBillingCountryZipCodeRegEx = $scope.teamSelectedCountryZipCodeRegEx;
                    $scope.teamBillingCountryZipCodeRequiredFlag = $scope.teamCountryZipCodeRequiredFlag;

                }
            }
        }

        $scope.$watch('[indSubscriptionData.indState, indSubscriptionData.indAddress, indSubscriptionData.indAddress2, indSubscriptionData.indCity, indSubscriptionData.indZipCode, teamSubscriptionData.teamState, teamSubscriptionData.teamAddress, teamSubscriptionData.teamAddress2, teamSubscriptionData.teamCity, teamSubscriptionData.teamZipCode]', function (newValue, oldValue) {
            $scope.chkbillingAddress();
        });

        //to test zip code valid or not at the time of page load
        $scope.$on('$viewContentLoaded', function () {
            $timeout(function () {
                $scope.indSelectedCountryZipCodeRegEx = $scope.indSelectedCountryZipCodeRegEx == undefined ? $('option:selected', $('#indCountry')).attr('validateRegex') : $scope.indSelectedCountryZipCodeRegEx;
                $scope.indCountryZipCodeRequiredFlag = $scope.indCountryZipCodeRequiredFlag == undefined ? $('option:selected', $('#indCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false : $scope.indCountryZipCodeRequiredFlag;

                $scope.teamSelectedCountryZipCodeRegEx = $scope.teamSelectedCountryZipCodeRegEx == undefined ? $('option:selected', $('#teamCountry')).attr('validateRegex') : $scope.teamSelectedCountryZipCodeRegEx;
                $scope.teamCountryZipCodeRequiredFlag = $scope.teamCountryZipCodeRequiredFlag == undefined ? $('option:selected', $('#teamCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false : $scope.teamCountryZipCodeRequiredFlag;
                if ($routeParams.accessType == 'team') {
                    if ($scope.teamSubscriptionData.teamZipCode != '') {
                        var emailregx = new RegExp($scope.selectedCountryZipCodeRegEx);
                        if (!emailregx.test($scope.teamSubscriptionData.teamZipCode)) {
                            $scope.teamForm.teamZipCode.$dirty = true;
                            $scope.teamForm.teamZipCode.$invalid = true;
                        }
                    }
                } else {
                    if ($scope.indSubscriptionData.indZipCode != '') {
                        var emailregx = new RegExp($scope.selectedCountryZipCodeRegEx);
                        if (!emailregx.test($scope.indSubscriptionData.indZipCode)) {
                            $scope.indForm.indZipCode.$dirty = true;
                            $scope.indForm.indZipCode.$invalid = true;
                        }
                    }
                }
            }, 2000);
        });

        //state
        $scope.getstateData = function (code, checkZipCodeRequiredFlag) {
            $scope.indSelectedCountryZipCodeRegEx = checkZipCodeRequiredFlag ? $('option:selected', $('#indCountry')).attr('validateRegex') : $scope.indSelectedCountryZipCodeRegEx;
            $scope.indCountryZipCodeRequiredFlag = checkZipCodeRequiredFlag ? $('option:selected', $('#indCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false : $scope.indCountryZipCodeRequiredFlag;

            $scope.teamSelectedCountryZipCodeRegEx = checkZipCodeRequiredFlag ? $('option:selected', $('#teamCountry')).attr('validateRegex') : $scope.teamSelectedCountryZipCodeRegEx;
            $scope.teamCountryZipCodeRequiredFlag = checkZipCodeRequiredFlag ? $('option:selected', $('#teamCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false : $scope.teamCountryZipCodeRequiredFlag;

            upgradeService.getstateData(code).then(function (response) {
                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.states = response.data;
                    $scope.chkbillingAddress();
                    if ($scope.states.length > 0) {
                        $scope.indSubscriptionData.indOtherState = "";
                        $scope.teamSubscriptionData.teamOtherState = "";
                    } else {
                        $scope.indSubscriptionData.indState = "";
                        $scope.teamSubscriptionData.teamState = "";
                    }

                }
            });

            if ($scope.indSubscriptionData.indZipCode != '') {
                this.indForm.$dirty = true;
                this.indForm.indZipCode.$dirty = true;
            }

            if ($scope.teamSubscriptionData.teamZipCode != '') {
                this.teamForm.$dirty = true;
                this.teamForm.teamZipCode.$dirty = true;
            }
        }

        $scope.getBillingStateData = function (code) {

            upgradeService.getstateData(code).then(function (response) {
                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.billingstates = response.data;
                }
                progressBarService.hideProgressBar();
            });

            $scope.indSelectedBillingCountryZipCodeRegEx = $('option:selected', $('#indBillingCountry')).attr('validateRegex');
            $scope.indBillingCountryZipCodeRequiredFlag = $('option:selected', $('#indBillingCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false;

            $scope.teamSelectedBillingCountryZipCodeRegEx = $('option:selected', $('#teamBillingCountry')).attr('validateRegex');
            $scope.teamBillingCountryZipCodeRequiredFlag = $('option:selected', $('#teamBillingCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false;

            if ($scope.billingstates.length > 0) {
                $scope.indSubscriptionData.indBillingState = "";
                $scope.indSubscriptionData.indBillingOtherState = "";

                $scope.teamSubscriptionData.teamBillingState = "";
                $scope.teamSubscriptionData.teamBillingOtherState = "";
            }

            if ($scope.indSubscriptionData.indBillingZipCode != '') {
                this.indForm.$dirty = true;
                this.indForm.indBillingZipCode.$dirty = true;
            }

            if ($scope.teamSubscriptionData.teamBillingZipCode != '') {
                this.teamForm.$dirty = true;
                this.teamForm.teamBillingZipCode.$dirty = true;
            }
        }

        //country
        $scope.getcountryData = function () {
            progressBarService.showProgressBar();
            upgradeService.getcountryData().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.countries = response.data;
                    if ($scope.indSubscriptionData.indCountry != '') {
                        var indSubscriptionData = $filter('filter')($scope.countries, { countryIso2: $scope.indSubscriptionData.indCountry }, true)[0]
                        $scope.indCountryZipCodeRequiredFlag = indSubscriptionData.countryZipCodeRequiredFlag;
                        $scope.indSelectedCountryZipCodeRegEx = indSubscriptionData.countryValidationString;
                    }
                    if ($scope.teamSubscriptionData.teamCountry != '') {
                        var teamSubscriptionData = $filter('filter')($scope.countries, { countryIso2: $scope.teamSubscriptionData.teamCountry }, true)[0];
                        $scope.teamCountryZipCodeRequiredFlag = teamSubscriptionData.countryZipCodeRequiredFlag;
                        $scope.teamSelectedCountryZipCodeRegEx = teamSubscriptionData.countryValidationString;
                    }
                    if ($routeParams.accessType == 'team') {
                        $scope.getstateData($scope.teamSubscriptionData.teamCountry, false)
                    } else {
                        $scope.getstateData($scope.indSubscriptionData.indCountry, false)
                    }
                }
                progressBarService.hideProgressBar();
            });
        }

    }])
})();

app.service('indBulkPurchaseService', ['$cookies', function ($cookies) {
    var $scope = null;

    var isValidBulkSubscription = false;

    var getAccessOptionScope = function () {
        return $scope;
    }

    var setAccessOptionScope = function (scope) {
        $scope = scope;
    }

    return {
        getAccessOptionScope: getAccessOptionScope,
        setAccessOptionScope: setAccessOptionScope,
        isValidBulkSubscription: isValidBulkSubscription
    }

}]);


(function () {
    'use strict';

    app.controller('indBulkPurchaseController', ['$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', 'UpgradeService', '$routeParams', 'indBulkPurchaseService', function ($scope, $location, $cookies, progressBarService, $rootScope, $timeout, upgradeService, $routeParams, indBulkPurchaseService) {
        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return;
        }

        if (performance.navigation.type == 1 || indBulkPurchaseService.isValidBulkSubscription == false) {
            $location.path('/accessOption/ind');
        }

        $scope.couponMessage = "";

        var scope = indBulkPurchaseService.getAccessOptionScope();

        $scope.coupon = scope.coupon;

        $scope.currentProduct = scope.currentProduct;

        $scope.perSeat = scope.perSeat;

        $scope.indSubscriptionData = scope.indSubscriptionData;
        $scope.teamSubscriptionData = scope.teamSubscriptionData;

        $scope.purchasedCostEstimation = scope.purchasedCostEstimation;

        $scope.monthlyProduct = scope.monthlyProduct;

        $scope.yearlyProduct = scope.yearlyProduct;

        $scope.calculateTotal = function () {
            scope.calculateTotal($scope);
        };

        $scope.createSeats = function () {
            $scope.seats = [];

            for (var i = 0; i < parseInt($scope.indSubscriptionData.indOrderQuantity) ; i++) {
                $scope.seats.push({ email: "" });
            }

            $scope.calculateTotal();
        }

        $scope.createSeats();

        $scope.validateCoupon = function () {
            scope.validateCoupon($scope);

            //removeCouponMessage();
        }

        function removeCouponMessage() {
            $timeout(function () {
                delete $scope.couponMessage
                $('.couponMessage').removeClass('couponError')
                $('.couponMessage').removeClass('couponSuccess')
            }, 5000);
        }

        $scope.checkValidEmail = function (e) {
            var i, emailregx, invalid = false;

            emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            for (i = 0; i < $scope.seats.length; i++) {
                var email = $('#email' + i);
                if ($scope.seats[i].email != "" && $scope.seats[i].email != undefined) {
                    if (emailregx.test($scope.seats[i].email)) {
                        email.removeClass('border-red');
                    }
                    else {
                        invalid = true;
                        email.addClass('border-red');
                    }
                }
            }

            if (invalid == false) {
                for (var i = 0; i < $scope.seats.length; i++) {
                    var email = $('#email' + i);
                    for (var x = i + 1; x < $scope.seats.length; x++) {
                        var email = $('#email' + x);
                        if ($scope.seats[i].email == $scope.seats[x].email) {
                            invalid = true;
                            email.addClass('border-red');
                        }
                    }
                }
            }

            $scope.isDisabled = invalid;
        }

        $scope.subscribe = function () {

            progressBarService.showProgressBar();

            var assign = [];

            for (var i = 0; i < $scope.seats.length; i++) {
                assign.push({ eSpectraSubEmail: $scope.seats[i].email });
            }

            var upgradeData = {
                eSpectraLicenceKeyStatus: 'Assigned',
                eSpectraSubAssignedPersonEmail: scope.indSubscriptionData.indEmailId,
                subscriptionAssign: assign,
                eSpectraFirstName: scope.firstName,
                eSpectraLastName: scope.lastName,
                eSpectraOrderQty: scope.indSubscriptionData.indOrderQuantity,
                eSpectraOrderIsMonthly: scope.purchasedCostEstimation.isMonthly,
                eSpectraOrderTS: new Date(),
                eSpectraProductID: scope.purchasedCostEstimation.productId,
                eSpectraCCBillFirstName: scope.indSubscriptionData.indFirstName,
                eSpectraCCBillLastName: scope.indSubscriptionData.indLastName,
                eSpectraOrderTotalCost: scope.purchasedCostEstimation.grandTotal,
                eSpectraCCBillStreetAddrs1: scope.indSubscriptionData.indBillingAddress,
                eSpectraCCBillStreetAddrs2: scope.indSubscriptionData.indBillingAddress2,
                eSpectraCCBillCity: scope.indSubscriptionData.indBillingCity,
                eSpectraCCBillZipPostalCode: scope.indSubscriptionData.indBillingZipCode,
                eSpectraCCBillStateCode: scope.indSubscriptionData.indBillingState,
                eSpectraCCBillCountryID: scope.indSubscriptionData.indBillingCountry,
                eSpectraRecurringBillFlag: 0,
                eSpectraProdDiscountID: scope.coupon.prodDiscountID,
                RecurringAmount: scope.purchasedCostEstimation.recurringAmount
            }

            scope.getSignature(upgradeData, $scope);
        }
    }])
})();